import React, { PropTypes, Component } from 'react';
import { Styles } from 'material-ui';
import * as Colors from 'components/Material/Styles/Colors';
const { Spacing } = Styles;

const styles = {
  root: {
    display: 'inline-block',
    verticalAlign: ' middle'
  }
};

export default class CircularProgress extends Component {
  static displayName = 'ProgressLabel';

  static propTypes = {
    size: PropTypes.number,
    startDegree: PropTypes.number,
    endDegree: PropTypes.number,
    progressWidth: PropTypes.number,
    trackWidth: PropTypes.number,
    cornersWidth: PropTypes.number,
    progress: PropTypes.number,
    fillColor: PropTypes.string,
    trackColor: PropTypes.string,
    progressColor: PropTypes.string
  };

  static defaultProps = {
    fillColor: 'transparent',
    trackColor: 'rgba(255, 255, 255, 0.125)',
    progressColor: Colors.Colors.fullWhite,
    startDegree: 0,
    progress: 0,
    progressWidth: 4,
    trackWidth: 3.9,
    cornersWidth: 2,
    size: 1
  };

  getPoint(r, degree) {
    let size = this.props.size * Spacing.desktopKeylineIncrement - 24;
    let d = degree / 180 * Math.PI;

    return {
      x: r * Math.sin(d) + size / 2,
      y: this.props.trackWidth / 2 + r * (1 - Math.cos(d))
    };
  }

  render() {
    let size = this.props.size * Spacing.desktopKeylineIncrement - 24;
    let progress = this.props.progress;
    let r = size / 2 - this.props.trackWidth / 2;
    let startDegree = this.props.startDegree;
    let endDegree = startDegree + progress * 360 / 100;
    let s = this.getPoint(r, this.props.startDegree);
    let e = this.getPoint(r, endDegree);
    if (progress > 100) {
      progress = 0;
    } else if (progress < 0) {
      progress = 0;
    }
    let progressPath = null;
    if (progress < 50) {
      progressPath = `M ${s.x} ${s.y} A ${r} ${r}, 0, 0, 1, ${e.x},${e.y}`;
    } else {
      let m = this.getPoint(r, startDegree + 180);
      progressPath = `M ${s.x} ${s.y} A ${r} ${r}, 0, 0, 1, ${m.x},${m.y}
        M ${m.x} ${m.y} A ${r} ${r}, 0, 0, 1, ${e.x},${e.y}`;
    }

    let progressStyle = {
      strokeWidth: this.props.progressWidth,
      stroke: this.props.progressColor,
      fill: 'none'
    };

    let trackStyle = {
      fill: this.props.fillColor,
      stroke: this.props.trackColor,
      strokeWidth: this.props.trackWidth
    };

    let text;
    if (this.props.progress > 0) {
      text = (
        <text
          x={size / 2}
          y={size / 2}
          fontSize={size / 3}
          fill={this.props.progressColor}
          textAnchor="middle"
          style={{ alignmentBaseline: 'middle' }}
        >
          {Math.round(progress)}
        </text>
      );
    }

    return (
      <svg
        style={styles.root}
        {...this.props}
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
      >
        <circle cx={size / 2} cy={size / 2} r={r} style={trackStyle} />

        {progress > 0 ? <path d={progressPath} style={progressStyle} /> : null}

        {progress > 0 ? (
          <circle
            cx={s.x}
            cy={s.y}
            r={this.props.cornersWidth}
            fill={this.props.progressColor}
          />
        ) : null}

        {progress > 0 ? (
          <circle
            cx={e.x}
            cy={e.y}
            r={this.props.cornersWidth}
            fill={this.props.progressColor}
          />
        ) : null}
        {text}
        {this.props.children}
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Material/CircularProgress.js